import VisibilityIcon from "@material-ui/icons/Visibility";
import PropTypes from "prop-types";
import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import { Scrollbars } from "react-custom-scrollbars";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
//local-imports
import { clearGamerDetailAction } from "../../../store/actions/adminGamer";
import constant from "../../../util/constant";
import { formatNumberAsPerLocale } from "../../../util/helpers";
import { ScrollPage } from "../customScrollBar";
import CustomSlider from "../customSlider";
import ViewAllGamesModal from "../games/viewAllGamesModal";
import MultiSelectCheckbox from "../multiSelectCheckbox";
import TableHeaderRow from "../tableHeadingRow";

const { ROUTES, BRANDING: { APP_SHORT_NAME } } = constant;

const LinkedGamers = ( {
  values,
  gamersFilterList,
  handleSelectChange,
  multiSelectedItems,
  handleClearMultiSelect,
  debouncedGameChangeHandler,
  handleChange,
  min,
  maxLinkedGames,
  debouncedCashChangeHandler,
  maxAcqyrCashBalance,
  memoizedTableConfig,
  memoizedHandleClick,
  gamers,
  onScroll,
  viewAllGames,
  closeModal,
  linkedGamer = false,
  minAcqyrCashBalance = 0,
  minLinkedGames = 0,
  id = null,
  action,
  showFilter,
  fromPartner = false,
} ) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  let backUrl = ROUTES.GAMER_LIST;

  switch ( action ) {
    case "games":
      backUrl = ROUTES.ADMIN_GAME_DETAILS.replace( ":gameId", id );

      break;
    case "partner":
      backUrl = ROUTES.PARTNER_REQUEST_DETAIL.replace( ":id", id );

      break;
    default:
      break;
  }

  // Return parent component reference name.
  // Helps in forth navigation to gamer details page and back navigation accordingly.
  const getPageName = () => {
    if( action === "partner" ) {
      return "partnersLinkedGamers";
    }
    else if( action === "games" ) {
      return "gamesLinkedGamers";
    }

    return "gamers";
  };

  return (
    <>
      <div className='filter-tabs-wrapper'>
        <div className='filter-boxes offer-filter mr-0'>
          <div className={`filter-boxes mr-0 ${ !showFilter ? "" : "remove-filter" }`}>
            <Row>
              <Col md={4}>
                <Form.Group className='custom-multiselect mb-0' data-testid="full-name">
                  <Form.Label>Name</Form.Label>
                  <MultiSelectCheckbox
                    multiOptionsList={gamersFilterList}
                    handleSelectChange={handleSelectChange[ 0 ]}
                    multiSelectedItems={multiSelectedItems[ 0 ]}
                    handleClearMultiSelect={() => handleClearMultiSelect( "fullNames" )} />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className='custom-multiselect mb-0'>
                  <CustomSlider
                    values={values}
                    pointsHandler={debouncedGameChangeHandler}
                    handleChange={handleChange}
                    min={linkedGamer ? minLinkedGames : min}
                    max={maxLinkedGames}
                    minName={"dummyMinLinkedGames"}
                    maxName={"dummyMaxLinkedGames"}
                    label={"No. of Linked Games"}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className='custom-multiselect mb-0'>
                  <CustomSlider
                    values={values}
                    pointsHandler={debouncedCashChangeHandler}
                    handleChange={handleChange}
                    min={linkedGamer ? minAcqyrCashBalance : min}
                    max={maxAcqyrCashBalance}
                    minName={"dummyMinAcqyrCashBalance"}
                    maxName={"dummyMaxAcqyrCashBalance"}
                    label={linkedGamer ? `${ APP_SHORT_NAME } Points` : `acQyr Cash balance ${ APP_SHORT_NAME } Points ($)`}
                  />
                </Form.Group>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      {/* Table start from here */}
      <div className="table-container four-column">
        <div className="table-head">
          <div className="table-row">
            <TableHeaderRow
              configData={memoizedTableConfig}
              onAscOrder={memoizedHandleClick}
              onDescOrder={memoizedHandleClick}
            />
          </div>
        </div>
        <Scrollbars renderThumbVertical={ScrollPage}
          className={`custom-scroll-height ${ !showFilter ? "" : "full-height" }`}
          onScroll={onScroll}
        >
          <div className="table-body no-scrollbar" >
            {/* repeat this div */}
            {Boolean( gamers?.length ) && gamers?.map( ( gamersData, index ) => (
              <div className="table-row" key={index}>
                <div className="td">
                  <span className="strong">{gamersData.fullNames}</span>
                </div>
                <div className="td">
                  {gamersData.linkedGamesCount}
                  {Boolean( gamersData.linkedGames.length ) && ( <div onClick={() => viewAllGames( gamersData.linkedGames )}
                    className="link cursor-pointer" title="View All">
                    View All
                  </div> )}
                </div>
                <div className="td">{formatNumberAsPerLocale( gamersData.acqyrCashBalance )}</div>
                <div className="td">
                  <span className='icon cursor-pointer' onClick={() => {
                    dispatch( clearGamerDetailAction() );
                    history.push( {
                      pathname: ( ( fromPartner ? ROUTES.PARTNER_GAMER_SECTION : ROUTES.GAMER_SECTION )
                        .replace( ":gamerId", gamersData.userId ) ),
                      state: [ ...location.state,
                        ...[ { from: getPageName(), path: location.pathname, state: location.search } ],
                      ],
                      backScreenRoute: backUrl,
                    } );
                  }}>
                    <VisibilityIcon />
                  </span>
                </div>
              </div>
            ) )}
            {!gamers?.length && (
              <div className='no-record' data-testid='no-record-found'>
                No Gamer Found
              </div>
            )}
          </div>
        </Scrollbars>
      </div>
      {/* end table */}
      <ViewAllGamesModal
        values={values}
        closeModal={closeModal}
      />
    </>
  );
};

LinkedGamers.propTypes = {
  values: PropTypes.object,
  gamersFilterList: PropTypes.array,
  handleSelectChange: PropTypes.func,
  multiSelectedItems: PropTypes.func,
  handleClearMultiSelect: PropTypes.func,
  debouncedGameChangeHandler: PropTypes.func,
  handleChange: PropTypes.func,
  min: PropTypes.number,
  maxLinkedGames: PropTypes.number,
  debouncedCashChangeHandler: PropTypes.func,
  maxAcqyrCashBalance: PropTypes.number,
  memoizedTableConfig: PropTypes.object,
  memoizedHandleClick: PropTypes.func,
  gamers: PropTypes.array,
  onScroll: PropTypes.func,
  viewAllGames: PropTypes.func,
  closeModal: PropTypes.func,
  linkedGamer: PropTypes.bool,
  minAcqyrCashBalance: PropTypes.number,
  minLinkedGames: PropTypes.number,
  id: PropTypes.string,
  action: PropTypes.string,
  showFilter: PropTypes.string,
  fromPartner: PropTypes.bool,
};

export default LinkedGamers;
